import { session as _session } from 'lib_ui-services';

export default {
    verb: 'doingGet',
    namespace: 'security',
    relation: 'profile',
    description: 'get the current user profile',
    priority: 10,
    logic
};

const _p = {
    getSessionData: _session.getSessionData
};

export const _private = _p;

async function logic() {
    const session = await _p.getSessionData();
    return { result: [session.profile] };
}
